"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = exports.TabsWrapper = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.TabsWrapper = function (_a) {
    var className = _a.className, children = _a.children, restProps = tslib_1.__rest(_a, ["className", "children"]);
    return (react_1.default.createElement("div", tslib_1.__assign({ className: classnames_1.default("gd-tabs small is-condensed", className) }, restProps), children));
};
exports.Tab = function (_a) {
    var selected = _a.selected, className = _a.className, children = _a.children, restProps = tslib_1.__rest(_a, ["selected", "className", "children"]);
    return (react_1.default.createElement("div", tslib_1.__assign({ className: classnames_1.default(selected && "is-active", "gd-tab", className) }, restProps), children));
};
//# sourceMappingURL=Tabs.js.map